import { useMutation } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

import type { IFile } from '@model/file';

import { apiClient } from '@services/apiClient';

import type { IApiError, IClaimFormMutationsResponse } from '../model/claimFormMutations';

interface IFormData {
  fullName: string;
  title?: string;
  email: string;
  phone: string;
  companyFacility: string;
  shippingAddress: string;
  productType?: string;
  deviceNumber: string;
  equipmentLocation?: string;
  installDate: string | null;
  whatEnvironment: string[];
  description: string;
  attachments: IFile[];
}

const claimFormFn = (data: IFormData) => apiClient.post(`${APP_API_URL_V2}claim-form`, data);

export const useClaimFormMutation = () => {
  return useMutation<IClaimFormMutationsResponse, AxiosError<IApiError>, IFormData>({
    mutationFn: claimFormFn,
  });
};
